/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.AppointmentCategories {
    angular.module("meevo.plugins.appointmentCategories", []);
}